import { queryFirst, removeClass, addClass } from '../domUtil';
const { HIDDEN_CLASS } = require('../constants');
/**
 * Updates the data attributes of a product tile based on the provided active data.
 *
 * @param {HTMLElement} container - The container element that holds the product tile.
 * @param {Object} activeData - An object containing key-value pairs to set as data attributes.
 */
export function changeActiveDataDataParams(container, activeData) {
    // update active data attributes
    // Take all data attributes from productTile
    const dataAttributes = Array.from(container.attributes).filter(attr => attr.name.startsWith('data-product-ad-'));

    // Clear all data attributes by mask data-product-ad
    dataAttributes.forEach(attr => container.removeAttribute(attr.name));

    if (activeData) {
        Object.entries(activeData).forEach(([key, value]) => {
            container.setAttribute(`data-product-ad-${key}`, value);
        });
    }
}
/**
 * Updates the promotion block content based on the provided promotions.
 * @param {Array} promotions List of promotions
 * @param {HTMLElement} container The container element to update
 * @param {boolean} [excludeFromPromotions=false] Flag to indicate if the product is excluded from promotions
 * @param {boolean} [excludeFromAllPromotions=false] Flag to indicate if the product is excluded from all promotions
 * @param {boolean} [showGWPPromoIcon=true] Whether to show the GWP gift icon in the promo block
 * @returns {void}
 */
export function updatePromoBlockContent(promotions, container, excludeFromPromotions = false, excludeFromAllPromotions = false, showGWPPromoIcon = true) {
    if (!container) {
        return;
    }
    // Find the standard promo block container
    const standardPromoBlock = queryFirst('.js-promo-standard', container);
    // Find .js-promo-sheet-container inside .main-content
    const promoSheetContainer = queryFirst('#main-content .js-promo-sheet-container');
    // Find the promo block messages container
    let promoBlockMsg = queryFirst('.js-promo-block-messages', standardPromoBlock || container);
    // return if promo block or promo sheet container not found
    if (!standardPromoBlock || !promoBlockMsg || !promoSheetContainer) return;
    // Generate promo block messages and promo sheet messages based on the promotions data
    const { promoSheetMessageTmpl, promotionMessageTmpl } = require('../templates').productDetail;
    const isExcludeFromPromotions = !!(excludeFromPromotions || excludeFromAllPromotions);
    let promoBlockMessages = '';
    let promoSheetMessages = '';
    if (promotions && promotions.length > 0) {
        promotions.forEach(promotion => {
            if (promotion.calloutMsg) {
                promoBlockMessages += promotionMessageTmpl(promotion, isExcludeFromPromotions);
            }
            if (promotion.promoSheetId) {
                promoSheetMessages += promoSheetMessageTmpl(promotion.promoSheetId);
            }
        });
    }
    promoBlockMsg.innerHTML = promoBlockMessages;

    // Toggle GWP icon visibility based on current variant's promotions
    const promoBlockIcon = queryFirst('.promo-block-icon', standardPromoBlock);
    if (promoBlockIcon) {
        (showGWPPromoIcon ? removeClass : addClass)(promoBlockIcon, 'd-none');
    }

    // Toggle m-multiple class based on number of promotions
    const hasMultiplePromos = promoBlockMsg.querySelectorAll('.promo-block-item').length > 1;
    (hasMultiplePromos ? addClass : removeClass)(standardPromoBlock, 'm-multiple');

    promoSheetContainer.innerHTML = promoSheetMessages;

    // Toggle exclusion message visibility
    const exclusionMsg = queryFirst('.js-exclusion-msg', container);
    if (exclusionMsg) {
        (isExcludeFromPromotions ? removeClass : addClass)(exclusionMsg, HIDDEN_CLASS);
    }

    // Toggle promo blocks for all exclusions
    const allExcludedBlock = queryFirst('.js-promo-all-excluded', container);
    if (allExcludedBlock) {
        if (excludeFromAllPromotions) {
            addClass(standardPromoBlock, HIDDEN_CLASS);
            removeClass(allExcludedBlock, HIDDEN_CLASS);
        } else {
            // Only show standard block if there are promo messages to display
            (promoBlockMessages ? removeClass : addClass)(standardPromoBlock, HIDDEN_CLASS);
            addClass(allExcludedBlock, HIDDEN_CLASS);
        }
    }

    // Toggle standalone excludedFromPromotions block (message still shows when excluded but no callout promo messages are on the PDP)
    const excludedStandalone = queryFirst('.js-promo-excluded-standalone', container);
    if (excludedStandalone) {
        (excludeFromPromotions && !excludeFromAllPromotions && !promoBlockMessages ? removeClass : addClass)(excludedStandalone, HIDDEN_CLASS);
    }
}
